// extracted by mini-css-extract-plugin
module.exports = {"DfmCheckSection":"PnNWB8QHXhn1XD6uSLurCA==","collapsible":"OImiTF07xaWKESn0AqeoZw=="};